import { Component, HostListener, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { SharedService } from "../core/services/shared-service/shared.service";
import { HttpService } from "../core/services/http.service";
import { ProjectListService } from "../core/services/project-list/project-list.service";
import { CommonUtilService } from "../core/services/common-util-service";
import { SettingsService } from "../core/services/settings.service";
import { ToastrTranslateService } from "../core/services/toastr-translate.service";
import { CheckBox } from "../core/entity/checkBox";
import moment from "moment-timezone";
import { FormBuilder, FormGroup } from "@angular/forms";
import cronTime from "cron-time-generator";
import { forkJoin } from "rxjs";

@Component({
  selector: "app-dynamic-filter",
  templateUrl: "./dynamic-filter.component.html",
  styleUrls: ["./dynamic-filter.component.scss"],
})
export class DynamicFilterComponent implements OnInit {
  @Input() filterSet: any;
  @Output() filterArr: EventEmitter<string> = new EventEmitter<string>();

  dropdownIndex: any = -1;
  loggedInUser: any = null;
  derivedSettings: any = null;

  rangeDate: Date[];

  quickFilterFlag: any = false;
  colorbox: any = false;
  quickFilterName: any = null;
  selectedColor: any = "#007EBE";
  divColor: any = [];
  quickFilterArr: any = [];

  searchBu: any = null;
  companyList: any = [];
  selectedBuList: any = [];

  selectedContractArr: any = [];
  selectedContractArr1: any = [];
  butagsArr: any = [];
  filterService: any;
  filterData: any = null;

  functionList: any = [];

  personalFunctionCheckBoxList: any = [];
  perFnSearch: any = null;
  perFunArr: any = [];
  selectedPerFunctionCheckBoxList: any = [];

  selectedSkillCheckBoxList: any = [];
  skillArr: any = [];
  skillsCheckBoxList: any = [];
  skillSearch: any = null;

  perLocationCheckBoxList: any = [];
  selectedLocationPerCheckBoxList: any = [];
  locationArrPer: any = [];
  perLocSearch: any = null;

  freelancerCheckBoxList: any = [];
  selectedFreelancerCheckBoxList: any = [];
  freeArr: any = [];

  groupCheckBoxList: any = [];
  selectedGroupCheckBoxList: any = [];
  groupArr: any = [];
  groupSearch: any = null;

  equipmentFunctionCheckBoxList: any = [];
  euipFnSearch: any = null;
  selectedEquipFunctionCheckBoxList: any = [];
  equipFunArr: any = [];

  locationCheckBoxList: any = [];
  selectedLocationCheckBoxList: any = [];
  locationArr: any = [];
  equipLocSearch: any = null;

  modelCheckBoxList: any = [];
  selectedModelCheckBoxList: any = [];
  euipModalSearch: any = null;

  equipmentCheckBoxList: any = [];

  equipmentTypeCheckBoxList: any = [];
  selectedEquipmentTypeCheckBoxList: any = [];
  typeArr: any = [];
  equipTypeSearch: any = null;

  categoryCheckBoxListClient = [];
  clientCatSearch: any = null;
  selectedDomainCheckBoxList: any = [];

  locationCheckBoxListClient = [];
  selectedCityCheckBoxList: any = [];
  clientLocSearch: any = null;

  countryCheckBoxListCLient = [];
  selectedCountryCheckBoxListClient: any = [];
  clientConSearch: any = null;

  userTypeCheckBoxList: any = [];
  selectedUserType: any = [];

  personalTypeCheckBoxList: any = [];
  selectedPersonalType: any = [];

  bookedCheckBoxList: any = [];
  selectedBookedCheckBoxList1: any = [];
  activeArr: any = [];

  searchProject: any = null;
  projectArr: any = [];
  selectedProjectCheckBoxList: any = [];

  searchNetwork: any = null;
  networkList: any = [];
  selectedNetworkCheckBoxList: any = [];

  searchKit: any = null;
  kitArr: any = [];
  selectedKitCheckBoxList: any = [];

  searchClient: any = null;
  clientArr: any = [];
  selectedclientCheckBoxList: any = [];
  dclientArr: any = [];

  searchPlanningStatus: any = null;
  planningEventStatusList: any = [];
  selectedPlanningCheckBoxList: any = [];
  dPlanningArr: any = [];

  personalList: any = [];

  accountManagerCheckboxList: any = [];
  searchAccountManager: any = null;
  selectedAccountManagerList: any = [];
  accountManagertagsArr: any = [];

  projectOwnerCheckboxList: any = [];
  searchPOwner: any = null;
  selectedProjectOwnerList: any = [];
  ownertagsArr: any = [];

  phaseManagerCheckboxList: any = [];
  searchPhManager: any = null;
  selectedPhaseList: any = [];
  phasetagsArr: any = [];

  dropdownDataList: any = null;
  selectedCountryCheckBoxList: any = [];
  countryArr: any = [];
  searchCountry: any = null;

  regionArr: any = [];
  selectedRegionCheckBoxList: any = [];
  searchRegion: any = null;

  actualArr: any = [];
  selectedActualCheckBoxList: any = [];
  searchActual: any = null;

  selectedCategoryCheckBoxList: any = [];
  categoryArr: any = [];
  searchCategory: any = null;

  selectedExportCheckBoxList: any = [];
  exportArr: any = [];

  selectedFinancailCheckBoxList: any = [];
  financialArr: any = [];

  selectedTimeOffCheckBoxList: any = [];
  timeOffArr: any = [];

  groupDropDown: any = [];

  browserTimeZone: any;

  mediaDropDown: any = [];
  mediaSupport: any = [];
  mediaSupportList: any = [];
  selectedmediaSupportBoxList: any = [];
  mediaArr: any = [];
  mediaSearch: any = null;

  mediaFormate: any = [];
  mediaFormateData: any = [];
  selectedMediaFormtBoxList: any = [];
  mediaFormatArr: any = [];
  mediaFormatSearch: any = null;

  mediaStatusBoxList: any = [];
  selectedMediaStatusBoxList: any = [];
  mediaStatusArr: any = [];
  mediaStatusSearch: any = null;

  patchObj: any = {};

  hidePhasemanagerFilter: any = false;

  cronModaLFlag: any = false;
  selctedCronJob: any = null;
  automationTab: any = 0;
  cronForm: FormGroup;
  selectedWeekDays: String = "";
  selectedWeekNumbers: String = "";
  cronHourIncrementIncrementArr: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
  cronHourIncrementStartArr: any = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"];
  cronDowDaysStartArr: any = [
    { name: "Sunday", val: 1, checked: false },
    { name: "Monday", val: 2, checked: true },
    { name: "Tuesday", val: 3, checked: false },
    { name: "Wednesday", val: 4, checked: false },
    { name: "Thursday", val: 5, checked: false },
    { name: "Friday", val: 6, checked: false },
    { name: "Saturday", val: 7, checked: false },
  ];
  cronDowWeeksArr: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  cronMonthsArr: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
  cronEveryMonthArr: any = [
    { name: "January", val: 1, shotName: "JAN" },
    { name: "February", val: 2, shotName: "FEB" },
    { name: "March", val: 3, shotName: "MAR" },
    { name: "April", val: 4, shotName: "APR" },
    { name: "May", val: 5, shotName: "MAY" },
    { name: "June", val: 6, shotName: "JUN" },
    { name: "July", val: 7, shotName: "JUL" },
    { name: "August", val: 8, shotName: "AUG" },
    { name: "September", val: 9, shotName: "SEP" },
    { name: "October", val: 10, shotName: "OCT" },
    { name: "November", val: 11, shotName: "Nov" },
    { name: "December", val: 12, shotName: "DEC" },
  ];
  twentyFourhourFormatArr: any = [
    "01:00",
    "01:30",
    "02:00",
    "02:30",
    "03:00",
    "03:30",
    "04:00",
    "04:30",
    "05:00",
    "05:30",
    "06:00",
    "06:30",
    "07:00",
    "07:30",
    "08:00",
    "08:30",
    "09:00",
    "09:30",
    "10:00",
    "10:30",
    "11:00",
    "11:30",
    "12:00",
    "12:30",
    "13:00",
    "13:30",
    "14:00",
    "14:30",
    "15:00",
    "15:30",
    "16:00",
    "16:30",
    "17:00",
    "17:30",
    "18:00",
    "18:30",
    "19:00",
    "19:30",
    "20:00",
    "20:30",
    "21:00",
    "21:30",
    "22:00",
    "23:00",
    "23:30",
    "00:00",
  ];
  twelveFourhourFormatArr: any = [
    "12:00am",
    "12:30am",
    "01:00am",
    "01:30am",
    "02:00am",
    "02:30am",
    "03:00am",
    "03:30am",
    "04:00am",
    "04:30am",
    "05:00am",
    "05:30am",
    "06:00am",
    "06:30am",
    "07:00am",
    "07:30am",
    "08:00am",
    "08:30am",
    "09:00am",
    "09:30am",
    "10:00am",
    "10:30am",
    "11:00am",
    "11:30am",
    "12:00pm",
    "12:30pm",
    "01:00pm",
    "01:30pm",
    "02:00pm",
    "02:30pm",
    "03:00pm",
    "03:30pm",
    "04:00pm",
    "04:30pm",
    "05:00pm",
    "05:30pm",
    "06:00pm",
    "06:30pm",
    "07:00pm",
    "07:30pm",
    "08:00pm",
    "08:30pm",
    "09:00pm",
    "09:30pm",
    "10:00pm",
    "10:30pm",
    "11:00pm",
    "11:30pm",
  ];
  selectedGroup: any = null;
  selectGroupArr1: any = [];
  selectedRecipient: any = [];
  selectMembers: any = [];
  selectedGroupIds: any = [];
  assignedGroup1: any = "";
  groupIds1: any = [];
  runningJobObj: any = null;
  productionGroupList: any = [];
  groupCronName: any = [];
  hiddenFilter: any = false;
  compName: any = null;
  screenName: any = null;

  cronMinuteArr: any = ["2", "5", "10", "15", "20", "25", "30", "35", "40", "45", "50"];

  selectedQuickFilter: any = null;
  selectedQuickFilterId: any = null;
  expandedRecipientIndex: number | null = null;

  constructor(private sharedService: SharedService, private formBuilder: FormBuilder, private toastr: ToastrTranslateService, private httpService: HttpService, private projectListService: ProjectListService, private settingsService: SettingsService, private commonUtilService: CommonUtilService) {
    this.filterService = sharedService;
    this.derivedSettings = this.settingsService.derivedSettigs;
    this.cronForm = this.createCronForm();
  }

  ngOnInit(): void {
    if (window.location.href.includes("dashboard/actual") || window.location.href.includes("dashboard/process") || window.location.href.includes("dashboard/incident")) {
      this.hiddenFilter = true;
    }
    if (this.filterSet && this.filterSet.hasOwnProperty("compName")) {
      this.compName = this.filterSet.compName;
      this.screenName = this.filterSet.screenName;
    }
    this.loggedInUser = this.sharedService.getLoggedInUserData();
    this.browserTimeZone = this.loggedInUser != null && this.loggedInUser.userSettingDTO != undefined && this.loggedInUser.userSettingDTO.timeZone != undefined ? this.loggedInUser.userSettingDTO.timeZone : "UTC";
    this.patchObj = this.sharedService.filterSelectedObj[this.screenName || "default"] || {};
    this.getQuickFilters();
    this.getCompanyList();
    this.getColors();
    this.getCheckedWeekDays(null, null);
    this.getProductionGroupData();
    if (this.compName == "schedule" || this.compName == "board") {
      this.getAllProjectDataName();
      this.getclients();
      this.getAllPersonnel();
      this.getAllRegion();
      this.getDropDopdown();
      this.getcategory();
    }
    if (this.compName == "show") {
      this.getAllProjectDataName();
      this.getclients();
      this.getAllPersonnel();
      this.getNetworkData();
    }

    if (this.compName == "equipment") {
      this.getAllFunction();
      this.equipDropdown();
    }

    if (this.compName == "personal" || this.compName == "userAccount") {
      this.getAllFunction();
      this.getDropDownData();
      this.getgroup();
    }

    if (this.compName == "taskView") {
      this.getAllProjectDataName();
      // this.getAllPersonnelData();
    }

    if (this.compName == "client") {
      this.clientCategory();
    }

    if (this.compName == "asset") {
      this.getclients();
      this.getAllProjectDataName();
    }

    if (this.compName == "media") {
      this.getclients();
      this.getAllProjectDataName();
      this.getMediaSupportList();
    }

    if (this.compName == "reports" || this.compName == "reportResource") {
      this.getAllProjectDataName();
      this.getclients();
      this.getAllPlanningEventStatus();
      this.getAllFunction();
      this.getDropDownData();
      this.getDropDopdown();
      this.getAllPersonnel();

      this.sharedService.AllKitListByLoggedInUser$.subscribe(() => {
        this.getAllKitListByLoggedInUser();
      });

      this.exportArr = new Array();
      this.financialArr = new Array();
      this.timeOffArr = new Array();
      this.exportArr.push(new CheckBox("Exported", "Exported", false));
      this.exportArr.push(new CheckBox("UnExported", "UnExported", false));
      this.financialArr.push(new CheckBox("Push-to-Financial", "Push-to-Financial", false));
      this.timeOffArr.push(new CheckBox("Time Off", "Time Off", false));
      if (this.patchObj.hasOwnProperty("isexported")) {
        this.selectedExportCheckBoxList = [];

        let list = this.patchObj.isexported.split(",");
        for (let i = 0; i < list.length; i++) {
          const element = list[i];
          const label = element == "true" ? "Exported" : "UnExported";
          let index = this.exportArr.findIndex((el) => el.label == label);
          if (index != -1) {
            this.exportArr[index].checked = true;
            this.selectedExportCheckBoxList.push(this.exportArr[index].label);
          }
        }
      }
      if (this.patchObj.hasOwnProperty("finacialRequired")) {
        this.selectedFinancailCheckBoxList = [];

        let list = this.patchObj.finacialRequired;
        if (list) {
          let index = this.financialArr.findIndex((el) => el.label == "Push-to-Financial");
          if (index != -1) {
            this.financialArr[index].checked = true;
            this.selectedFinancailCheckBoxList.push(this.financialArr[index].label);
          }
        }
      }
      if (this.patchObj.hasOwnProperty("timeOffR")) {
        this.selectedTimeOffCheckBoxList = [];

        let list = this.patchObj.timeOffR;
        if (list) {
          let index = this.timeOffArr.findIndex((el) => el.label == "Time Off");
          if (index != -1) {
            this.timeOffArr[index].checked = true;
            this.selectedTimeOffCheckBoxList.push(this.timeOffArr[index].label);
          }
        }
      }
    }

    this.setFilterFrom();
  }

  implimentFilter(filter) {
    this.filterArr.emit(filter.filterString);
    if (filter) {
      this.onQuickFilterChange(filter.filterName);
    }
  }

  applyFilters() {
    if (this.compName == "schedule" || this.compName == "board") {
      let obj: any = {
        project: this.selectedProjectCheckBoxList.toString(),
        clientId: this.selectedclientCheckBoxList.toString(),
        projectOwner: this.selectedProjectOwnerList.toString(),
        buId: this.selectedBuList.toString(),
        phaseOwner: this.selectedPhaseList.toString(),
        accountManger: this.selectedAccountManagerList.toString(),
        region: this.selectedRegionCheckBoxList.toString(),
        country: this.selectedCountryCheckBoxList.toString(),
        category: this.selectedCategoryCheckBoxList.toString(),
      };
      if (this.selectedActualCheckBoxList.length > 0) {
        obj["isActualised"] = this.selectedActualCheckBoxList[0] == "Actualized" ? "true" : "false";
      }
      if (this.compName == "board") {
        let start = this.rangeDate != null ? this.rangeDate[0] : null;
        let end = this.rangeDate != null ? this.rangeDate[1] : null;

        let startIsoDate = null;
        let endIsoDate = null;

        if (start != null) {
          startIsoDate = moment(new Date(start)).tz(this.browserTimeZone, true).toISOString().split(".")[0];
        }

        if (end != null) {
          endIsoDate = moment(new Date(end)).tz(this.browserTimeZone, true).toISOString().split(".")[0];
        }
        if (startIsoDate != null) {
          obj.startDate = startIsoDate;
        }
        if (startIsoDate != null) {
          obj.endDate = endIsoDate;
        }
      }

      const filteredObj = this.filterNullValues(obj);
      this.sharedService.filterSelectedObj[this.screenName || "default"] = filteredObj;

      this.filterArr.emit(JSON.stringify(this.filterNullValues(obj)));
    }

    if (this.compName == "show") {
      let obj: any = {
        project: this.selectedProjectCheckBoxList.toString(),
        clientId: this.selectedclientCheckBoxList.toString(),
        projectOwner: this.selectedProjectOwnerList.toString(),
        buId: this.selectedBuList.toString(),
        phaseOwner: this.selectedPhaseList.toString(),
        accountManger: this.selectedAccountManagerList.toString(),
        network: this.selectedNetworkCheckBoxList.toString(),
      };

      const filteredObj = this.filterNullValues(obj);
      this.sharedService.filterSelectedObj[this.screenName || "default"] = filteredObj;

      this.filterArr.emit(JSON.stringify(this.filterNullValues(obj)));
    }

    if (this.compName == "equipment") {
      let obj = {
        functionid: this.selectedEquipFunctionCheckBoxList.toString(),
        buId: this.selectedBuList.toString(),
        model: this.selectedModelCheckBoxList.toString(),
        location: this.selectedLocationCheckBoxList.toString(),
        type: this.selectedEquipmentTypeCheckBoxList.toString(),
      };
      if (this.selectedBookedCheckBoxList1.length > 0) {
        obj["isactive"] = this.selectedBookedCheckBoxList1[0] == "Active" ? "true" : "false";
      }

      const filteredObj = this.filterNullValues(obj);
      this.sharedService.filterSelectedObj[this.screenName || "default"] = filteredObj;

      this.filterArr.emit(JSON.stringify(this.filterNullValues(obj)));
    }

    if (this.compName == "personal" || this.compName == "userAccount") {
      let obj = {
        functionid: this.selectedPerFunctionCheckBoxList.toString(),
        buId: this.selectedBuList.toString(),
        skillname: this.selectedSkillCheckBoxList.toString(),
        stafflocation: this.selectedLocationPerCheckBoxList.toString(),
        groupid: this.selectedGroupCheckBoxList.toString(),
      };
      if (this.selectedFreelancerCheckBoxList.length > 0) {
        obj["contractListId"] = this.selectedFreelancerCheckBoxList.toString();
      }
      if (this.selectedContractArr.length > 0) {
        obj["contractTypeId"] = this.selectedContractArr.toString();
      }
      if (this.selectedBookedCheckBoxList1.length > 0) {
        obj["isactive"] = this.selectedBookedCheckBoxList1[0] == "Active" ? "true" : "false";
      }
      let arr = [];
      if (this.selectedUserType.length > 0) {
        if (this.selectedUserType.some((el) => el == "Regular")) {
          arr.push(1);
        }
        if (this.selectedUserType.some((el) => el == "Lite User")) {
          arr.push(6);
        }
        if (this.selectedUserType.some((el) => el == "Collaborator")) {
          arr.push(2);
        }
        obj["userType"] = arr.toString();
      }

      if (this.selectedPersonalType.length == 1) {
        obj["activeUsers"] = this.selectedPersonalType[0] == "Active" ? "true" : "false";
      }
      const filteredObj = this.filterNullValues(obj);
      this.sharedService.filterSelectedObj[this.screenName || "default"] = filteredObj;

      this.filterArr.emit(JSON.stringify(this.filterNullValues(obj)));
    }

    if (this.compName == "client") {
      let obj = {
        buId: this.selectedBuList.toString(),
        city: this.selectedCityCheckBoxList.toString(),
        country: this.selectedCountryCheckBoxListClient.toString(),
        category: this.selectedDomainCheckBoxList.toString(),
      };
      const filteredObj = this.filterNullValues(obj);
      this.sharedService.filterSelectedObj[this.screenName || "default"] = filteredObj;

      this.filterArr.emit(JSON.stringify(this.filterNullValues(obj)));
    }

    if (this.compName == "taskView") {
      let obj = {
        buId: this.selectedBuList.toString(),
        project: this.selectedProjectCheckBoxList.toString(),
      };
      const filteredObj = this.filterNullValues(obj);
      this.sharedService.filterSelectedObj[this.screenName || "default"] = filteredObj;

      this.filterArr.emit(JSON.stringify(this.filterNullValues(obj)));
    }

    if (this.compName == "reports" || this.compName == "reportResource") {
      let obj = {
        buId: this.selectedBuList.toString(),
        project: this.selectedProjectCheckBoxList.toString(),
        kitId: this.selectedKitCheckBoxList.toString(),
        clientId: this.selectedclientCheckBoxList.toString(),
        phasestatusId: this.selectedPlanningCheckBoxList.toString(),
        phaseOwner: this.selectedPhaseList.toString(),
        accountManger: this.selectedAccountManagerList.toString(),
      };
      if (this.selectedCountryCheckBoxList.length > 0) {
        obj["country"] = this.selectedCountryCheckBoxList.toString();
      }
      if (this.selectedFreelancerCheckBoxList.length > 0) {
        obj["contractListId"] = this.selectedFreelancerCheckBoxList.toString();
      }
      if (this.selectedEquipFunctionCheckBoxList.length > 0) {
        obj["functionId"] = this.selectedEquipFunctionCheckBoxList.toString();
      }
      if (this.selectedPerFunctionCheckBoxList.length > 0) {
        obj["functionId"] = this.selectedPerFunctionCheckBoxList.toString();
      }
      if (this.selectedContractArr.length > 0) {
        obj["contractTypeId"] = this.selectedContractArr.toString();
      }
      if (this.selectedEquipFunctionCheckBoxList.length > 0) {
        obj["functionId"] = this.selectedEquipFunctionCheckBoxList.toString();
      }
      if (this.selectedPerFunctionCheckBoxList.length > 0) {
        obj["functionId"] = this.selectedPerFunctionCheckBoxList.toString();
      }
      if (this.selectedFinancailCheckBoxList.length > 0) {
        obj["finacialRequired"] = true;
      } else {
        obj["finacialRequired"] = false;
      }

      if (this.selectedTimeOffCheckBoxList.length > 0) {
        obj["timeOffR"] = true;
      } else {
        obj["timeOffR"] = false;
      }
      if (this.selectedExportCheckBoxList.length > 0) {
        let flag = this.replaceExportStatus(this.selectedExportCheckBoxList);
        obj["isexported"] = flag;
      }

      const filteredObj = this.filterNullValues(obj);
      this.sharedService.filterSelectedObj[this.screenName || "default"] = filteredObj;

      this.filterArr.emit(JSON.stringify(this.filterNullValues(obj)));
    }

    if (this.compName == "asset") {
      let obj = {
        clientId: this.selectedclientCheckBoxList.toString(),
        projectId: this.selectedProjectCheckBoxList.toString(),
      };

      const filteredObj = this.filterNullValues(obj);
      this.sharedService.filterSelectedObj[this.screenName || "default"] = filteredObj;

      this.filterArr.emit(JSON.stringify(this.filterNullValues(obj)));
    }

    if (this.compName == "media") {
      let obj = {
        clientId: this.selectedclientCheckBoxList.toString(),
        projectId: this.selectedProjectCheckBoxList.toString(),
        mediaSupportId: this.selectedmediaSupportBoxList.toString(),
        mediaFormatId: this.selectedMediaFormtBoxList.toString(),
      };
      const filteredObj = this.filterNullValues(obj);
      this.sharedService.filterSelectedObj[this.screenName || "default"] = filteredObj;

      this.filterArr.emit(JSON.stringify(this.filterNullValues(obj)));
    }
  }

  replaceExportStatus(arr) {
    if (!arr || arr.length === 0) return ""; // Handle empty or undefined input

    return arr
      .map((item) => (item === "Exported" ? "true" : item === "UnExported" ? "false" : ""))
      .filter(Boolean)
      .join(",");
  }

  clearBUFilter() {
    this.selectedBuList = [];
    this.butagsArr = [];
    this.companyList = this.companyList.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearEqupFunction() {
    this.selectedEquipFunctionCheckBoxList = [];
    this.equipFunArr = [];
    this.equipmentFunctionCheckBoxList = this.equipmentFunctionCheckBoxList.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearModalEquipment() {
    this.selectedModelCheckBoxList = [];
    this.modelCheckBoxList = this.modelCheckBoxList.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearLocationEquip() {
    this.selectedLocationCheckBoxList = [];
    this.locationCheckBoxList = this.locationCheckBoxList.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearTypeEquip() {
    this.selectedEquipmentTypeCheckBoxList = [];
    this.equipmentTypeCheckBoxList = this.equipmentTypeCheckBoxList.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearActive() {
    this.selectedBookedCheckBoxList1 = [];
    this.bookedCheckBoxList = this.bookedCheckBoxList.map((el) => {
      el.checked = false;
      return el;
    });
  }
  clearUserType() {
    this.selectedUserType = [];
    this.userTypeCheckBoxList = this.userTypeCheckBoxList.map((el) => {
      el.checked = false;
      return el;
    });
  }
  clearPersonalType() {
    this.selectedPersonalType = [];
    this.personalTypeCheckBoxList = this.personalTypeCheckBoxList.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearActual() {
    this.selectedActualCheckBoxList = [];
    this.actualArr = this.actualArr.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearFunctionPersonal() {
    this.selectedPerFunctionCheckBoxList = [];
    this.personalFunctionCheckBoxList = this.personalFunctionCheckBoxList.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearSkillPersonal() {
    this.selectedSkillCheckBoxList = [];
    this.skillsCheckBoxList = this.skillsCheckBoxList.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearTypePersonaal() {
    this.selectedFreelancerCheckBoxList = [];
    this.selectedContractArr = [];
    this.freeArr = [];
    this.freelancerCheckBoxList = this.freelancerCheckBoxList.map((el) => {
      el.checked = false;
      if (el.listValues && el.listValues.length > 0) {
        el.listValues = el.listValues.map((child) => {
          child.checked = false;
          return child;
        });
      }
      return el;
    });
  }

  clearLocationPersonal() {
    this.selectedLocationPerCheckBoxList = [];
    this.perLocationCheckBoxList = this.perLocationCheckBoxList.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearGroupPersonal() {
    this.selectedGroupCheckBoxList = [];
    this.groupCheckBoxList = this.groupCheckBoxList.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearCategoryCLient() {
    this.selectedDomainCheckBoxList = [];
    this.categoryCheckBoxListClient = this.categoryCheckBoxListClient.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearCityCLient() {
    this.selectedCityCheckBoxList = [];
    this.locationCheckBoxListClient = this.locationCheckBoxListClient.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearCountryClient() {
    this.selectedCountryCheckBoxListClient = [];
    this.countryCheckBoxListCLient = this.countryCheckBoxListCLient.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearScheduleProject() {
    this.selectedProjectCheckBoxList = [];
    this.projectArr = this.projectArr.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearNetwork() {
    this.selectedNetworkCheckBoxList = [];
    this.networkList = this.networkList.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearKit() {
    this.selectedKitCheckBoxList = [];
    this.kitArr = this.kitArr.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearScheduleClient() {
    this.selectedclientCheckBoxList = [];
    this.clientArr = this.clientArr.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearPlanning() {
    this.selectedPlanningCheckBoxList = [];
    this.planningEventStatusList = this.planningEventStatusList.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearProjectOwner() {
    this.selectedProjectOwnerList = [];
    this.projectOwnerCheckboxList = this.projectOwnerCheckboxList.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearPhaseOwner() {
    this.selectedPhaseList = [];
    this.phaseManagerCheckboxList = this.phaseManagerCheckboxList.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearAccountManager() {
    this.selectedAccountManagerList = [];
    this.accountManagerCheckboxList = this.accountManagerCheckboxList.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearCountrySchedule() {
    this.selectedCountryCheckBoxList = [];
    this.countryArr = this.countryArr.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearRegionSchedule() {
    this.selectedRegionCheckBoxList = [];
    this.regionArr = this.regionArr.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearCategorySchedule() {
    this.selectedCategoryCheckBoxList = [];
    this.categoryArr = this.categoryArr.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearExport() {
    this.selectedExportCheckBoxList = [];
    this.exportArr = this.exportArr.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearFinancail() {
    this.selectedFinancailCheckBoxList = [];
    this.financialArr = this.financialArr.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearTimeOff() {
    this.selectedTimeOffCheckBoxList = [];
    this.timeOffArr = this.timeOffArr.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearMediaSupport() {
    this.selectedmediaSupportBoxList = [];
    this.mediaSupportList = this.mediaSupportList.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearMediaFormat() {
    this.selectedMediaFormtBoxList = [];
    this.mediaFormateData = this.mediaFormateData.map((el) => {
      el.checked = false;
      return el;
    });
  }

  clearAllfilters() {
    if (this.screenName && this.sharedService.filterSelectedObj) {
      delete this.sharedService.filterSelectedObj[this.screenName];
    }
    // clear BU
    this.clearBUFilter();

    //****************************************** Schedule ***************************************

    //clear Project
    this.clearScheduleProject();

    //clear Network
    this.clearNetwork();

    //clear Kit
    this.clearKit();

    //clear Client
    this.clearScheduleClient();

    // clear Planning
    this.clearPlanning();

    //clear ProjectoWner
    this.clearProjectOwner();

    //clear PhaseManger
    this.clearPhaseOwner();

    //clear Account manager
    this.clearAccountManager();

    //clear Region
    this.clearRegionSchedule();

    //clear Country
    this.clearCountrySchedule();

    //clear Category
    this.clearCategorySchedule();

    // clear actual
    this.clearActual();

    //****************************************** Equipment ***************************************

    //clear function
    this.clearEqupFunction();

    //clear Model
    this.clearModalEquipment();

    //clear Location
    this.clearLocationEquip();

    //clear Type
    this.clearTypeEquip();

    //clear Active
    this.clearActive();

    //clear usertype
    this.clearUserType();

    //****************************************** Personal ***************************************

    //clear function
    this.clearFunctionPersonal();

    //clear Location
    this.clearLocationPersonal();

    //clear Skill
    this.clearSkillPersonal();

    //clear Type
    this.clearTypePersonaal();

    //clear Group
    this.clearGroupPersonal();

    //****************************************** Client ***************************************

    //clear country
    this.clearCountryClient();

    //clear Category
    this.clearCategoryCLient();

    //clear City
    this.clearCityCLient();

    this.clearExport();

    this.clearFinancail();
    this.clearTimeOff();
    this.clearPersonalType();

    //****************************************** asset ***************************************
    this.clearMediaSupport();
    this.clearMediaFormat();

    this.filterArr.emit(null);
  }

  openDropDownModal(seletedIndex) {
    if (this.dropdownIndex == seletedIndex) {
      this.dropdownIndex = -1;
    } else {
      this.dropdownIndex = seletedIndex;
    }
  }

  setFilterFrom() {
    this.filterData = this.sharedService.getuserFilters();
    if (this.filterData?.staffMemberId != undefined && this.filterData?.staffMemberId != null) {
      if (this.filterData.values["GLOBALFILTER"] != undefined) {
        for (let i = 0; i < this.filterData.values["GLOBALFILTER"].length; i++) {
          if (this.filterData.values.GLOBALFILTER[i].recordKey == "LISTFILTERARR") {
            if (this.filterData.values.GLOBALFILTER[i].recordValue == null || this.filterData.values.GLOBALFILTER[i].recordValue == "") {
              continue;
            }
            this.sharedService.selectedFilterArr = this.filterData.values.GLOBALFILTER[i].recordValue.split(",");
          }
        }
      }
    }
    // this.applyFilters()
  }

  getColors() {
    this.httpService.callApi("getColors", {}).subscribe(
      (response) => {
        this.divColor = response;
      },
      (error) => {}
    );
  }

  updateTheme(color: any) {
    this.selectedColor = color;
  }

  async saveQuickFIlter() {
    try {
      if (this.quickFilterName == null || this.quickFilterName == "") {
        this.toastr.warning("Please enter a filter name. It cannot be empty.");
      }

      let obj: any = null;

      if (this.compName == "schedule" || this.compName == "board") {
        obj = {
          project: this.selectedProjectCheckBoxList.toString(),
          buId: this.selectedBuList.toString(),
          clientId: this.selectedclientCheckBoxList.toString(),
          projectOwner: this.selectedProjectOwnerList.toString(),
          phaseOwner: this.selectedPhaseList.toString(),
          accountManger: this.selectedAccountManagerList.toString(),
          region: this.selectedRegionCheckBoxList.toString(),
          country: this.selectedCountryCheckBoxList.toString(),
          category: this.selectedCategoryCheckBoxList.toString(),
        };
        if (this.selectedActualCheckBoxList.length > 0) {
          obj["isActualised"] = this.selectedActualCheckBoxList[0] == "Actualized" ? "true" : "false";
        }
      }

      if (this.compName == "show") {
        obj = {
          project: this.selectedProjectCheckBoxList.toString(),
          buId: this.selectedBuList.toString(),
          clientId: this.selectedclientCheckBoxList.toString(),
          projectOwner: this.selectedProjectOwnerList.toString(),
          phaseOwner: this.selectedPhaseList.toString(),
          accountManger: this.selectedAccountManagerList.toString(),
          network: this.selectedNetworkCheckBoxList.toString(),
        };
      }

      if (this.compName == "equipment") {
        obj = {
          buId: this.selectedBuList.toString(),
          functionid: this.selectedEquipFunctionCheckBoxList.toString(),
          model: this.selectedModelCheckBoxList.toString(),
          location: this.selectedLocationCheckBoxList.toString(),
          type: this.selectedEquipmentTypeCheckBoxList.toString(),
        };

        if (this.selectedBookedCheckBoxList1.length > 0) {
          obj["isactive"] = this.selectedBookedCheckBoxList1[0] == "Active" ? "true" : "false";
        }
      }

      if (this.compName == "personal" || this.compName == "userAccount") {
        obj = {
          buId: this.selectedBuList.toString(),
          functionid: this.selectedPerFunctionCheckBoxList.toString(),
          skillname: this.selectedSkillCheckBoxList.toString(),
          stafflocation: this.selectedLocationPerCheckBoxList.toString(),
          isactive: this.selectedBookedCheckBoxList1.toString() == "Active" ? true : false,
          groupid: this.selectedGroupCheckBoxList.toString(),
        };
        let arr = [];
        if (this.selectedUserType.length > 0) {
          if (this.selectedUserType.some((el) => el == "Regular")) {
            arr.push(1);
          }
          if (this.selectedUserType.some((el) => el == "Lite User")) {
            arr.push(6);
          }
          if (this.selectedUserType.some((el) => el == "Collaborator")) {
            arr.push(2);
          }
          obj["userType"] = arr.toString();
        }
        if (this.selectedPersonalType.length == 0) {
          obj["activeUsers"] = this.selectedPersonalType[0] == "Active" ? "true" : "false";
        }
        if (this.selectedFreelancerCheckBoxList.length > 0) {
          obj["contractListId"] = this.selectedFreelancerCheckBoxList.toString();
        }
        if (this.selectedContractArr.length > 0) {
          obj["contractTypeId"] = this.selectedContractArr.toString();
        }
      }

      if (this.compName == "taskView") {
        obj = {
          buId: this.selectedBuList.toString(),
          project: this.selectedProjectCheckBoxList.toString(),
        };
      }

      if (this.compName == "client") {
        obj = {
          buId: this.selectedBuList.toString(),
          city: this.selectedCityCheckBoxList.toString(),
          country: this.selectedCountryCheckBoxListClient.toString(),
          category: this.selectedDomainCheckBoxList.toString(),
        };
      }

      if (this.compName == "reports" || this.compName == "reportResource") {
        obj = {
          buId: this.selectedBuList.toString(),
          project: this.selectedProjectCheckBoxList.toString(),
          KitId: this.selectedKitCheckBoxList.toString(),
          clientId: this.selectedclientCheckBoxList.toString(),
          phasestatusId: this.selectedPlanningCheckBoxList.toString(),
          phaseOwner: this.selectedPhaseList.toString(),
          accountManger: this.selectedAccountManagerList.toString(),
        };
        if (this.selectedCountryCheckBoxList.length > 0) {
          obj["country"] = this.selectedCountryCheckBoxList.toString();
        }
        if (this.selectedEquipFunctionCheckBoxList.length > 0) {
          obj["functionId"] = this.selectedEquipFunctionCheckBoxList.toString();
        }
        if (this.selectedPerFunctionCheckBoxList.length > 0) {
          obj["functionId"] = this.selectedPerFunctionCheckBoxList.toString();
        }
        if (this.selectedFreelancerCheckBoxList.length > 0) {
          obj["contractListId"] = this.selectedFreelancerCheckBoxList.toString();
        }
        if (this.selectedContractArr.length > 0) {
          obj["contractTypeId"] = this.selectedContractArr.toString();
        }

        if (this.selectedFinancailCheckBoxList.length > 0) {
          obj["finacialRequired"] = true;
        } else {
          obj["finacialRequired"] = false;
        }

        if (this.selectedTimeOffCheckBoxList.length > 0) {
          obj["timeOffR"] = true;
        } else {
          obj["timeOffR"] = false;
        }

        if (this.selectedExportCheckBoxList.length > 0) {
          let flag = this.replaceExportStatus(this.selectedExportCheckBoxList);
          obj["isexported"] = flag;
        }

        if (this.compName == "asset") {
          obj = {
            clientId: this.selectedclientCheckBoxList.toString(),
            projectId: this.selectedProjectCheckBoxList.toString,
          };
        }
      }

      let filterobj = {
        id: null,
        user: { id: this.loggedInUser.id },
        filterName: this.quickFilterName,
        filtertheme: this.selectedColor,
        filterModule: this.compName,
        filterString: JSON.stringify(this.filterNullValues(obj)),
      };

      const res: any = await this.commonUtilService.saveQuickFilters(filterobj);

      this.quickFilterArr.push(filterobj);
      this.quickFilterName = null;
      this.quickFilterFlag = false;
      this.selectedColor = "#007EBE";
    } catch (error) {
      console.log(error);
    }
  }

  filterNullValues(obj: any): any {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      if (value != null && value != "") {
        acc[key] = value;
      } else if (value === false) {
        acc[key] = value;
      }
      return acc;
    }, {});
  }

  async getQuickFilters() {
    try {
      let userID = localStorage.getItem("userId");
      const res: any = await this.commonUtilService.getQuickFilters(userID);
      if (res && res.length > 0) {
        for (let i = 0; i < res.length; i++) {
          const element = res[i];
          if (this.compName == element.filterModule) {
            this.quickFilterArr.push(element);
          }
        }
      }
      console.log("this is saved filter list", this.quickFilterArr);
    } catch (error) {
      console.log(error);
    }
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  async removeQuickFilter(filter) {
    try {
      const res: any = await this.commonUtilService.deleteQuickFilters(filter.id);
      this.quickFilterArr.splice(this.quickFilterArr.indexOf(filter), 1);
    } catch (error) {
      console.log(error);
    }
  }

  getCompanyList() {
    this.companyList = [];
    this.httpService.callApi("getCompanyDropdown", {}).subscribe(
      (response) => {
        if (this.loggedInUser.companyId == 123456789987) {
          this.companyList = response.map((data) => ({
            ...data,
            checked: false,
          }));
        } else {
          this.companyList = response.filter((el) => el.id == this.loggedInUser.companyId || el.id == 123456789987).map((data) => ({ ...data, checked: false }));
        }
        if (this.patchObj.hasOwnProperty("buId")) {
          this.selectedBuList = [];

          let list = this.patchObj.buId.split(",");
          for (let i = 0; i < list.length; i++) {
            const element = list[i];
            let index = this.companyList.findIndex((el) => el.id == element);
            if (index != -1) {
              this.companyList[index].checked = true;
              this.selectedBuList.push(this.companyList[index].id);
            }
          }
        }
        console.log("this is company list", this.companyList);
        console.log("this is selectedBuList list", this.selectedBuList);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getMediaSupportList() {
    this.httpService.callApi("getMediaDropDownData", {}).subscribe(
      (response) => {
        if (response.mediaSupportList) {
          this.mediaSupport = response.mediaSupportList || [];

          this.mediaSupportList = this.mediaSupport.map((data) => ({
            ...data,
            checked: false,
          }));
          console.log("this is media supportList", this.mediaSupportList);

          if (this.patchObj.hasOwnProperty("mediaSupportList")) {
            this.selectedmediaSupportBoxList = [];

            let list = this.patchObj.mediaSupportList.split(",");
            for (let i = 0; i < list.length; i++) {
              const element = list[i];
              let index = this.mediaSupportList.findIndex((el) => el.id == element);
              if (index != -1) {
                this.mediaSupportList[index].checked = true;
                this.selectedmediaSupportBoxList.push(this.mediaSupportList[index].id);
              }
            }
          }
        }

        if (response.formats) {
          this.mediaFormate = response.formats || [];
          this.mediaFormateData = this.mediaFormate.map((data) => ({
            ...data,
            checked: false,
          }));
          console.log("this is media formate", this.mediaFormate);

          if (this.patchObj.hasOwnProperty("mediaFormateData")) {
            this.selectedMediaFormtBoxList = [];

            let list = this.patchObj.mediaFormateData.split(",");
            for (let i = 0; i < list.length; i++) {
              const element = list[i];
              let index = this.mediaFormateData.findIndex((el) => el.id == element);
              if (index != -1) {
                this.mediaFormateData[index].checked = true;
                this.selectedMediaFormtBoxList.push(this.mediaFormateData[index].id);
              }
            }
          }
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  async getAllFunction() {
    try {
      if (this.sharedService.getglobalFuncions().length != 0) {
        this.equipmentFunctionCheckBoxList = [];
        this.personalFunctionCheckBoxList = [];
        this.functionList = this.sharedService.getglobalFuncions().map((data) => ({ ...data, checked: false }));
        for (let fun of this.functionList) {
          if (fun.type == "Equipment") {
            this.equipmentFunctionCheckBoxList.push(fun);
          }
          if (fun.type == "Personnel") {
            this.personalFunctionCheckBoxList.push(fun);
          }
        }
        if (this.patchObj.hasOwnProperty("functionid")) {
          this.selectedEquipFunctionCheckBoxList = [];

          let list = this.patchObj.functionid.split(",");
          console.log(list);

          for (let i = 0; i < list.length; i++) {
            const element = list[i];
            let index = this.equipmentFunctionCheckBoxList.findIndex((el) => el.id == element);
            if (index != -1) {
              this.equipmentFunctionCheckBoxList[index].checked = true;
              this.selectedEquipFunctionCheckBoxList.push(this.equipmentFunctionCheckBoxList[index].id);
            }
          }
        }
        if (this.patchObj.hasOwnProperty("functionId")) {
          this.selectedEquipFunctionCheckBoxList = [];

          let list = this.patchObj.functionId.split(",");
          console.log(list);

          for (let i = 0; i < list.length; i++) {
            const element = list[i];
            let index = this.equipmentFunctionCheckBoxList.findIndex((el) => el.id == element);
            if (index != -1) {
              this.equipmentFunctionCheckBoxList[index].checked = true;
              this.selectedEquipFunctionCheckBoxList.push(this.equipmentFunctionCheckBoxList[index].id);
            }
          }
        }
        if (this.patchObj.hasOwnProperty("functionid")) {
          this.selectedPerFunctionCheckBoxList = [];

          let list = this.patchObj.functionid.split(",");
          console.log(list);
          for (let i = 0; i < list.length; i++) {
            const element = list[i];
            let index = this.personalFunctionCheckBoxList.findIndex((el) => el.id == element);
            if (index != -1) {
              this.personalFunctionCheckBoxList[index].checked = true;
              this.selectedPerFunctionCheckBoxList.push(this.personalFunctionCheckBoxList[index].id);
            }
          }
        }
        if (this.patchObj.hasOwnProperty("functionId")) {
          this.selectedPerFunctionCheckBoxList = [];

          let list = this.patchObj.functionId.split(",");
          console.log(list);
          for (let i = 0; i < list.length; i++) {
            const element = list[i];
            let index = this.personalFunctionCheckBoxList.findIndex((el) => el.id == element);
            if (index != -1) {
              this.personalFunctionCheckBoxList[index].checked = true;
              this.selectedPerFunctionCheckBoxList.push(this.personalFunctionCheckBoxList[index].id);
            }
          }
        }
      } else {
        const res: any = await this.commonUtilService.getAllFUnctionData();
        this.equipmentFunctionCheckBoxList = [];
        this.personalFunctionCheckBoxList = [];
        if (res.functions.length > 0) {
          this.functionList = res.functions.map((data) => ({
            ...data,
            checked: false,
          }));
          for (let fun of this.functionList) {
            if (fun.type == "Equipment") {
              this.equipmentFunctionCheckBoxList.push(fun);
            }
            if (fun.type == "Personnel") {
              this.personalFunctionCheckBoxList.push(fun);
            }
          }
          this.sharedService.multipleCallRemover(res.functions, "function");
        }
        if (this.patchObj.hasOwnProperty("functionid")) {
          this.selectedEquipFunctionCheckBoxList = [];

          let list = this.patchObj.functionid.split(",");
          console.log(list);

          for (let i = 0; i < list.length; i++) {
            const element = list[i];
            let index = this.equipmentFunctionCheckBoxList.findIndex((el) => el.id == element);
            if (index != -1) {
              this.equipmentFunctionCheckBoxList[index].checked = true;
              this.selectedEquipFunctionCheckBoxList.push(this.equipmentFunctionCheckBoxList[index].id);
            }
          }
        }
        if (this.patchObj.hasOwnProperty("functionId")) {
          this.selectedEquipFunctionCheckBoxList = [];

          let list = this.patchObj.functionId.split(",");
          console.log(list);

          for (let i = 0; i < list.length; i++) {
            const element = list[i];
            let index = this.equipmentFunctionCheckBoxList.findIndex((el) => el.id == element);
            if (index != -1) {
              this.equipmentFunctionCheckBoxList[index].checked = true;
              this.selectedEquipFunctionCheckBoxList.push(this.equipmentFunctionCheckBoxList[index].id);
            }
          }
        }
        if (this.patchObj.hasOwnProperty("functionid")) {
          this.selectedPerFunctionCheckBoxList = [];

          let list = this.patchObj.functionid.split(",");
          console.log(list);

          for (let i = 0; i < list.length; i++) {
            const element = list[i];
            let index = this.personalFunctionCheckBoxList.findIndex((el) => el.id == element);
            if (index != -1) {
              this.personalFunctionCheckBoxList[index].checked = true;
              this.selectedPerFunctionCheckBoxList.push(this.personalFunctionCheckBoxList[index].id);
            }
          }
        }
        if (this.patchObj.hasOwnProperty("functionId")) {
          this.selectedPerFunctionCheckBoxList = [];

          let list = this.patchObj.functionId.split(",");
          console.log(list);

          for (let i = 0; i < list.length; i++) {
            const element = list[i];
            let index = this.personalFunctionCheckBoxList.findIndex((el) => el.id == element);
            if (index != -1) {
              this.personalFunctionCheckBoxList[index].checked = true;
              this.selectedPerFunctionCheckBoxList.push(this.personalFunctionCheckBoxList[index].id);
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async equipDropdown() {
    try {
      this.locationCheckBoxList = [];
      this.modelCheckBoxList = [];
      this.equipmentTypeCheckBoxList = [];
      const resequipment: any = await this.commonUtilService.getEquipmentDropDown();
      if (resequipment.locations)
        for (let location of resequipment.locations) {
          this.locationCheckBoxList.push(new CheckBox(location, location, false));
          if (this.patchObj.hasOwnProperty("location")) {
            this.selectedLocationCheckBoxList = [];
            let list = this.patchObj.location.split(",");
            for (let i = 0; i < list.length; i++) {
              const element = list[i];
              let index = this.locationCheckBoxList.findIndex((el) => el.label == element);
              if (index != -1) {
                this.locationCheckBoxList[index].checked = true;
                this.selectedLocationCheckBoxList.push(this.locationCheckBoxList[index].label);
              }
            }
          }
        }

      if (resequipment.models)
        for (let model of resequipment.models) {
          this.modelCheckBoxList.push(new CheckBox(model, model, false));
          if (this.patchObj.hasOwnProperty("model")) {
            this.selectedModelCheckBoxList = [];
            let list = this.patchObj.model.split(",");
            for (let i = 0; i < list.length; i++) {
              const element = list[i];
              let index = this.modelCheckBoxList.findIndex((el) => el.label == element);
              if (index != -1) {
                this.modelCheckBoxList[index].checked = true;
                this.selectedModelCheckBoxList.push(this.modelCheckBoxList[index].label);
              }
            }
          }
        }

      if (resequipment.type)
        for (let type of resequipment.type) {
          this.equipmentTypeCheckBoxList.push(new CheckBox(type, type, false));
          if (this.patchObj.hasOwnProperty("type")) {
            this.selectedEquipmentTypeCheckBoxList = [];
            let list = this.patchObj.type.split(",");
            for (let i = 0; i < list.length; i++) {
              const element = list[i];
              let index = this.equipmentTypeCheckBoxList.findIndex((el) => el.label == element);
              if (index != -1) {
                this.equipmentTypeCheckBoxList[index].checked = true;
                this.selectedEquipmentTypeCheckBoxList.push(this.equipmentTypeCheckBoxList[index].label);
              }
            }
          }
        }

      this.bookedCheckBoxList = new Array();
      this.bookedCheckBoxList.push(new CheckBox("Active", true, false));
      this.bookedCheckBoxList.push(new CheckBox("InActive", true, false));
      if (this.patchObj.hasOwnProperty("isactive")) {
        this.selectedBookedCheckBoxList1 = [];

        let list = this.patchObj.isactive.split(",");
        for (let i = 0; i < list.length; i++) {
          const element = list[i];
          let index = this.bookedCheckBoxList.findIndex((el) => el.label == element);
          if (index != -1) {
            this.bookedCheckBoxList[index].checked = true;
            this.selectedBookedCheckBoxList1.push(this.bookedCheckBoxList[index].label);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getDropDownData() {
    try {
      const resDropDown: any = await this.commonUtilService.getPersonelDropDown();
      if (resDropDown.locations)
        for (let location of resDropDown.locations) {
          this.perLocationCheckBoxList.push(new CheckBox(location, location, false));
          if (this.patchObj.hasOwnProperty("stafflocation")) {
            this.selectedLocationPerCheckBoxList = [];
            let list = this.patchObj.stafflocation.split(",");
            for (let i = 0; i < list.length; i++) {
              const element = list[i];
              let index = this.perLocationCheckBoxList.findIndex((el) => el.label == element);
              if (index != -1) {
                this.perLocationCheckBoxList[index].checked = true;
                this.selectedLocationPerCheckBoxList.push(this.perLocationCheckBoxList[index].label);
              }
            }
          }
        }

      if (resDropDown.skills)
        for (let skill of resDropDown.skills) {
          this.skillsCheckBoxList.push(new CheckBox(skill, skill, false));
          if (this.patchObj.hasOwnProperty("skillname")) {
            this.selectedSkillCheckBoxList = [];

            let list = this.patchObj.skillname.split(",");
            for (let i = 0; i < list.length; i++) {
              const element = list[i];
              let index = this.skillsCheckBoxList.findIndex((el) => el.label == element);
              if (index != -1) {
                this.skillsCheckBoxList[index].checked = true;
                this.selectedSkillCheckBoxList.push(this.skillsCheckBoxList[index].label);
              }
            }
          }
        }

      this.freelancerCheckBoxList = new Array();
      for (let contract of resDropDown.contractTypes) {
        contract["checked"] = false;

        contract.listValues = contract.listValues.map((data) => ({
          ...data,
          checked: false,
        }));
        this.freelancerCheckBoxList.push(contract);
      }

      if (this.patchObj.hasOwnProperty("contractTypeId")) {
        this.selectedContractArr = [];
        let list = this.patchObj.contractTypeId.split(",");
        for (let i = 0; i < list.length; i++) {
          const element = list[i];
          let index = this.freelancerCheckBoxList.findIndex((el) => el.id == element);
          if (index != -1) {
            this.freelancerCheckBoxList[index].checked = true;
            this.selectedContractArr.push(this.freelancerCheckBoxList[index].id);
          }
        }
      }

      if (this.patchObj.hasOwnProperty("contractListId")) {
        this.selectedFreelancerCheckBoxList = [];
        let list = this.patchObj.contractListId.split(",");
        for (let i = 0; i < list.length; i++) {
          const element = list[i];
          for (let j = 0; j < this.freelancerCheckBoxList.length; j++) {
            const freeList = this.freelancerCheckBoxList[j];
            let index = freeList.listValues?.findIndex((el) => el.id == element);
            if (index != -1) {
              this.freelancerCheckBoxList[j].listValues[index].checked = true;
              this.selectedFreelancerCheckBoxList.push(this.freelancerCheckBoxList[j].listValues[index].id);
            }
          }
        }
      }

      this.bookedCheckBoxList = new Array();
      this.bookedCheckBoxList.push(new CheckBox("Active", true, false));
      this.bookedCheckBoxList.push(new CheckBox("InActive", true, false));
      if (this.patchObj.hasOwnProperty("isactive")) {
        this.selectedBookedCheckBoxList1 = [];

        let list = this.patchObj.isactive.split(",");
        for (let i = 0; i < list.length; i++) {
          const element = list[i];
          let index = this.bookedCheckBoxList.findIndex((el) => el.label == element);
          if (index != -1) {
            this.bookedCheckBoxList[index].checked = true;
            this.selectedBookedCheckBoxList1.push(this.bookedCheckBoxList[index].label);
          }
        }
      }

      this.userTypeCheckBoxList = new Array();
      this.userTypeCheckBoxList.push(new CheckBox("Regular", true, false));
      this.userTypeCheckBoxList.push(new CheckBox("Lite User", true, false));
      this.userTypeCheckBoxList.push(new CheckBox("Collaborator", true, false));
      if (this.patchObj.hasOwnProperty("userType")) {
        this.selectedUserType = [];

        let list = this.patchObj.userType.toString().split(",");
        for (let i = 0; i < list.length; i++) {
          const element = list[i];
          let MatchData = null;
          if (element == "1") {
            MatchData = "Regular";
          } else if (element == "6") {
            MatchData = "Lite User";
          } else {
            MatchData = "Collaborator";
          }
          let index = this.userTypeCheckBoxList.findIndex((el) => el.label == MatchData);
          if (index != -1) {
            this.userTypeCheckBoxList[index].checked = true;
            this.selectedUserType.push(this.userTypeCheckBoxList[index].label);
          }
        }
      }

      this.personalTypeCheckBoxList = new Array();
      this.personalTypeCheckBoxList.push(new CheckBox("Active", true, false));
      this.personalTypeCheckBoxList.push(new CheckBox("InActive", true, false));
      if (this.patchObj.hasOwnProperty("activeUsers")) {
        this.selectedPersonalType = [];
        let list = this.patchObj.activeUsers.toString().split(",");
        if (list[0] == "true") {
          this.personalTypeCheckBoxList[0].checked = true;
          this.selectedPersonalType.push(this.personalTypeCheckBoxList[0].label);
        } else {
          this.personalTypeCheckBoxList[1].checked = true;
          this.selectedPersonalType.push(this.personalTypeCheckBoxList[1].label);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getgroup() {
    try {
      const res: any = await this.commonUtilService.getConfigurationGroup();
      if (res.length > 0) {
        this.groupCheckBoxList = new Array();
        for (let grp of res) {
          this.groupCheckBoxList.push(new CheckBox(grp.name, grp.id, false));
        }
        if (this.patchObj.hasOwnProperty("groupid")) {
          this.selectedGroupCheckBoxList = [];

          let list = this.patchObj.groupid.split(",");
          for (let i = 0; i < list.length; i++) {
            const element = list[i];
            let index = this.groupCheckBoxList.findIndex((el) => el.value == element);
            if (index != -1) {
              this.groupCheckBoxList[index].checked = true;
              this.selectedGroupCheckBoxList.push(this.groupCheckBoxList[index].value);
            }
          }
        }
        this.sharedService.setglobalConfigGroup(res);
      }
    } catch (error) {}
  }

  getNetworkData = () => {
    let networkDataAPI = this.httpService.callApi("getNetworks", {});
    forkJoin([networkDataAPI]).subscribe(
      (resultList) => {
        if (resultList[0].length > 0) {
          this.networkList = resultList[0].map((data) => ({ ...data, checked: false }));
          if (this.patchObj.hasOwnProperty("network")) {
            this.selectedNetworkCheckBoxList = [];

            let list = this.patchObj.network.split(",");
            for (let i = 0; i < list.length; i++) {
              const element = list[i];
              let index = this.networkList.findIndex((el) => el.id == element);
              if (index != -1) {
                this.networkList[index].checked = true;
                this.selectedNetworkCheckBoxList.push(this.networkList[index].id);
              }
            }
          }
        }
      },
      (errorList) => {}
    );
  };

  async getAllProjectDataName() {
    try {
      const resp: any = await this.projectListService.getAllProjectDataName();

      if (resp.length > 0) {
        this.projectArr = resp.map((data) => ({
          ...data,
          title: `${data.projectname} (${data.clientname})`,
          checked: false,
        }));
        if (this.patchObj.hasOwnProperty("project")) {
          this.selectedProjectCheckBoxList = [];

          let list = this.patchObj.project.split(",");
          for (let i = 0; i < list.length; i++) {
            const element = list[i];
            let index = this.projectArr.findIndex((el) => el.id == element);
            if (index != -1) {
              this.projectArr[index].checked = true;
              this.selectedProjectCheckBoxList.push(this.projectArr[index].id);
            }
          }
        }
      }
    } catch (error) {}
  }

  async getAllKitListByLoggedInUser() {
    if (this.sharedService.getAllKitListByLoggedInUser().length != 0) {
      this.kitArr = [];
      let groupArr = this.sharedService.getAllKitListByLoggedInUser();
      for (let i = 0; i < groupArr.length; i++) {
        groupArr[i].checked = false;
        this.kitArr.push(groupArr[i]);
      }

      this.kitArr = this.kitArr.sort((a, b) => (a.kitIndex < b.kitIndex ? 1 : -1));
      if (this.patchObj.hasOwnProperty("kitId")) {
        this.selectedKitCheckBoxList = [];

        let list = this.patchObj.kitId.split(",");
        for (let i = 0; i < list.length; i++) {
          const element = list[i];
          let index = this.kitArr.findIndex((el) => el.id == element);
          if (index != -1) {
            this.kitArr[index].checked = true;
            this.selectedKitCheckBoxList.push(this.kitArr[index].id);
          }
        }
      }
    } else {
      try {
        const res: any = await this.commonUtilService.getAllKitListByLoggedInUser();
        if (res.length > 0) {
          this.sharedService.setAllKitListByLoggedInUser(res);
        }
        // }
      } catch (error) {}
    }
  }

  async getclients() {
    try {
      const res: any = await this.commonUtilService.getClientsApiBasic();
      this.clientArr = res.map((data) => ({ ...data, checked: false }));
      if (this.patchObj.hasOwnProperty("clientId")) {
        this.selectedclientCheckBoxList = [];

        let list = this.patchObj.clientId.split(",");
        for (let i = 0; i < list.length; i++) {
          const element = list[i];
          let index = this.clientArr.findIndex((el) => el.id == element);
          if (index != -1) {
            this.clientArr[index].checked = true;
            this.selectedclientCheckBoxList.push(this.clientArr[index].id);
          }
        }
      }
    } catch (error) {}
  }

  async getAllPlanningEventStatus() {
    try {
      const res: any = await this.commonUtilService.getAllPlanningEventStatusList();
      this.planningEventStatusList = res.map((data) => ({
        ...data,
        checked: false,
      }));
      if (this.patchObj.hasOwnProperty("phasestatusId")) {
        this.selectedPlanningCheckBoxList = [];

        let list = this.patchObj.phasestatusId.split(",");
        for (let i = 0; i < list.length; i++) {
          const element = list[i];
          let index = this.planningEventStatusList.findIndex((el) => el.id == element);
          if (index != -1) {
            this.planningEventStatusList[index].checked = true;
            this.selectedPlanningCheckBoxList.push(this.planningEventStatusList[index].id);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getAllPersonnel() {
    this.accountManagerCheckboxList = [];
    this.projectOwnerCheckboxList = [];
    this.phaseManagerCheckboxList = [];
    try {
      const res: any = await this.commonUtilService.getAllPersonelManagers("Phase Manager");
      const res1: any = await this.commonUtilService.getAllPersonelManagers("Project Owner");
      const res2: any = await this.commonUtilService.getAllPersonelManagers("Account Manager");
      if (res) {
        this.phaseManagerCheckboxList = res.map((el) => {
          el.checked = false;
          return el;
        });
      }
      if (res1) {
        this.projectOwnerCheckboxList = res1.map((el) => {
          el.checked = false;
          return el;
        });
      }
      if (res2) {
        this.accountManagerCheckboxList = res2.map((el) => {
          el.checked = false;
          return el;
        });
      }
    } catch (error) {
      console.log(error);
      // this.blockedPanel = false;
    }

    if (this.patchObj.hasOwnProperty("accountManger")) {
      this.selectedAccountManagerList = [];

      let list = this.patchObj.accountManger.split(",");
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let index = this.accountManagerCheckboxList.findIndex((el) => el.id == element);
        if (index != -1) {
          this.accountManagerCheckboxList[index].checked = true;
          this.selectedAccountManagerList.push(this.accountManagerCheckboxList[index].id);
        }
      }
    }

    if (this.patchObj.hasOwnProperty("projectOwner")) {
      this.selectedProjectOwnerList = [];

      let list = this.patchObj.projectOwner.split(",");
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let index = this.projectOwnerCheckboxList.findIndex((el) => el.id == element);
        if (index != -1) {
          this.projectOwnerCheckboxList[index].checked = true;
          this.selectedProjectOwnerList.push(this.projectOwnerCheckboxList[index].id);
        }
      }
    }

    if (this.patchObj.hasOwnProperty("phaseOwner")) {
      this.selectedPhaseList = [];

      let list = this.patchObj.phaseOwner.split(",");
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let index = this.phaseManagerCheckboxList.findIndex((el) => el.id == element);
        if (index != -1) {
          this.phaseManagerCheckboxList[index].checked = true;
          this.selectedPhaseList.push(this.phaseManagerCheckboxList[index].id);
        }
      }
    }
  }

  getDropDopdown() {
    this.httpService.callApi("getProjectDropdown", {}).subscribe((response) => {
      this.dropdownDataList = response;
      if (this.dropdownDataList != undefined && this.dropdownDataList.countries != undefined) {
        this.countryArr = this.dropdownDataList.countries.map((el) => Object.assign({ checked: false, name: el }));
        if (this.patchObj.hasOwnProperty("country")) {
          this.selectedCountryCheckBoxList = [];

          let list = this.patchObj.country.split(",");
          for (let i = 0; i < list.length; i++) {
            const element = list[i];
            let index = this.countryArr.findIndex((el) => el.name == element);
            if (index != -1) {
              this.countryArr[index].checked = true;
              this.selectedCountryCheckBoxList.push(this.countryArr[index].name);
            }
          }
        }
      } else {
        this.countryArr = [];
      }
    });
  }

  async getAllRegion() {
    try {
      const res: any = await this.commonUtilService.getAllRegion();
      if (res != undefined && res.length > 0) {
        this.regionArr = res.map((el) => Object.assign(el, { checked: false }));
        if (this.patchObj.hasOwnProperty("region")) {
          this.selectedRegionCheckBoxList = [];

          let list = this.patchObj.region.split(",");
          for (let i = 0; i < list.length; i++) {
            const element = list[i];
            let index = this.regionArr.findIndex((el) => el.name == element);
            if (index != -1) {
              this.regionArr[index].checked = true;
              this.selectedRegionCheckBoxList.push(this.regionArr[index].name);
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getcategory() {
    this.actualArr = new Array();
    this.actualArr.push(new CheckBox("Actualized", true, false));
    this.actualArr.push(new CheckBox("Not Actualized", true, false));
    if (this.patchObj.hasOwnProperty("isActualised")) {
      this.selectedActualCheckBoxList = [];

      let list = this.patchObj.isActualised.split(",");
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let index = this.selectedActualCheckBoxList.findIndex((el) => el.label == element);
        if (index != -1) {
          this.selectedActualCheckBoxList[index].checked = true;
          this.selectedActualCheckBoxList.push(this.selectedActualCheckBoxList[index].label);
        }
      }
    }

    try {
      const res: any = await this.commonUtilService.getProjectCategory();
      if (res.length > 0) {
        this.categoryArr = res.map((el) => Object.assign(el, { checked: false }));
        if (this.patchObj.hasOwnProperty("category")) {
          this.selectedCategoryCheckBoxList = [];

          let list = this.patchObj.category.split(",");
          for (let i = 0; i < list.length; i++) {
            const element = list[i];
            let index = this.categoryArr.findIndex((el) => el.name == element);
            if (index != -1) {
              this.categoryArr[index].checked = true;
              this.selectedCategoryCheckBoxList.push(this.categoryArr[index].name);
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async clientCategory() {
    try {
      const res: any = await this.commonUtilService.getClientDropDown();
      this.categoryCheckBoxListClient = [];
      this.locationCheckBoxListClient = [];
      this.countryCheckBoxListCLient = [];
      if (res.cities) {
        for (let location of res.cities) {
          this.locationCheckBoxListClient.push(new CheckBox(location, location, false));
          if (this.patchObj.hasOwnProperty("city")) {
            this.selectedCityCheckBoxList = [];

            let list = this.patchObj.city.split(",");
            for (let i = 0; i < list.length; i++) {
              const element = list[i];
              let index = this.locationCheckBoxListClient.findIndex((el) => el.label == element);
              if (index != -1) {
                this.locationCheckBoxListClient[index].checked = true;
                this.selectedCityCheckBoxList.push(this.locationCheckBoxListClient[index].label);
              }
            }
          }
        }
      }

      if (res.category) {
        for (let domain of res.category) {
          this.categoryCheckBoxListClient.push(new CheckBox(domain.name, domain.name, false));
          if (this.patchObj.hasOwnProperty("category")) {
            this.selectedDomainCheckBoxList = [];

            let list = this.patchObj.category.split(",");
            for (let i = 0; i < list.length; i++) {
              const element = list[i];
              let index = this.categoryCheckBoxListClient.findIndex((el) => el.label == element);
              if (index != -1) {
                this.categoryCheckBoxListClient[index].checked = true;
                this.selectedDomainCheckBoxList.push(this.categoryCheckBoxListClient[index].label);
              }
            }
          }
        }
      }

      if (res.countryList) {
        for (let country of res.countryList) {
          this.countryCheckBoxListCLient.push(new CheckBox(country, country, false));
          if (this.patchObj.hasOwnProperty("country")) {
            this.selectedCountryCheckBoxListClient = [];
            let list = this.patchObj.country.split(",");
            for (let i = 0; i < list.length; i++) {
              const element = list[i];
              let index = this.countryCheckBoxListCLient.findIndex((el) => el.label == element);
              if (index != -1) {
                this.countryCheckBoxListCLient[index].checked = true;
                this.selectedCountryCheckBoxListClient.push(this.countryCheckBoxListCLient[index].label);
              }
            }
          }
        }
      }
    } catch (error) {}
  }

  filterClientCategory(filterData: CheckBox) {
    filterData.checked = !filterData.checked;
    if (this.selectedDomainCheckBoxList.indexOf(filterData.label) >= 0) {
      this.selectedDomainCheckBoxList.splice(this.selectedDomainCheckBoxList.indexOf(filterData.label), 1);
    } else {
      this.selectedDomainCheckBoxList.push(filterData.label);
      this.quickFilterFlag = true;
    }
  }

  filterClientLocation(filterData: CheckBox) {
    filterData.checked = !filterData.checked;
    if (this.selectedCityCheckBoxList.indexOf(filterData.label) >= 0) {
      this.selectedCityCheckBoxList.splice(this.selectedCityCheckBoxList.indexOf(filterData.label), 1);
    } else {
      this.selectedCityCheckBoxList.push(filterData.label);
      this.quickFilterFlag = true;
    }
  }

  filterClientCountry(filterData: CheckBox) {
    filterData.checked = !filterData.checked;
    if (this.selectedCountryCheckBoxListClient.indexOf(filterData.label) >= 0) {
      this.selectedCountryCheckBoxListClient.splice(this.selectedCountryCheckBoxListClient.indexOf(filterData.label), 1);
    } else {
      this.selectedCountryCheckBoxListClient.push(filterData.label);
      this.quickFilterFlag = true;
    }
  }

  filterBU(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedBuList.push(checkBox.id);
      this.butagsArr.push(checkBox.name);
      this.quickFilterFlag = true;
    } else {
      this.selectedBuList.splice(this.selectedBuList.indexOf(checkBox.id), 1);
      this.butagsArr.splice(this.butagsArr.indexOf(checkBox.name), 1);
    }
  }

  personalCheckbox(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedPerFunctionCheckBoxList.push(checkBox.id);
      this.perFunArr.push(checkBox.value);
      this.quickFilterFlag = true;
    } else {
      this.selectedPerFunctionCheckBoxList.splice(this.selectedPerFunctionCheckBoxList.indexOf(checkBox.id), 1);
      this.perFunArr.splice(this.perFunArr.indexOf(checkBox.value), 1);
    }
  }

  addSelectedSkillCheckbox(checkBox: CheckBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedSkillCheckBoxList.push(checkBox.value);
      this.skillArr.push(checkBox.label);
      this.quickFilterFlag = true;
    } else {
      this.selectedSkillCheckBoxList.splice(this.selectedSkillCheckBoxList.indexOf(checkBox.value), 1);
      this.skillArr.splice(this.skillArr.indexOf(checkBox.label), 1);
    }
  }

  selectListAll(free) {
    if (free.listValues.length > 0) {
      free.listValues.forEach((element) => {
        this.addSelectedFreelanceCheckbox(free, element);
      });
    } else {
      this.addSelectedFreelanceCheckbox(free, null);
    }
  }

  addSelectedFreelanceCheckbox(checkBox, listCheckBox) {
    checkBox.checked = !checkBox.checked;
    let checkbox: any = document.getElementById(`dynamicFilterperfreeP-${checkBox.contractname}`);
    let checkVal = checkbox.checked;
    if (listCheckBox) {
      listCheckBox.checked = !listCheckBox.checked;
      if (listCheckBox.checked) {
        let checkboxChid: any = document.getElementById(`dynamicFilterperfree-${listCheckBox.listValue}`);
        checkboxChid.checked = true;
        this.selectedFreelancerCheckBoxList.push(listCheckBox.id);
        let isParent = this.selectedContractArr1.includes(checkBox.id);
        if (isParent) {
          checkBox.checked = !checkBox.checked;
        }
        this.selectedContractArr1.push(checkBox.id);
        this.quickFilterFlag = true;
      } else {
        let index = this.selectedFreelancerCheckBoxList.indexOf(listCheckBox.id);
        this.selectedFreelancerCheckBoxList.splice(index, 1);

        if (this.selectedFreelancerCheckBoxList.length > 0) {
          const selectedChildArr = this.freelancerCheckBoxList.flatMap((p) => p.listValues).filter((obj) => this.selectedFreelancerCheckBoxList.includes(obj.id));
          const parentArr = selectedChildArr.filter((el) => this.selectedContractArr1.includes(el.keywordstatus));
          if (parentArr.length > 0) {
            checkBox.checked = !checkBox.checked;
          }
          this.selectedContractArr1.splice(index, 1);
        } else {
          this.selectedContractArr1.splice(index, 1);
        }
      }
    } else {
      if (checkVal) {
        this.selectedContractArr1.push(checkBox.id);
        this.quickFilterFlag = true;
      } else {
        this.selectedContractArr1.splice(this.selectedContractArr1.indexOf(checkBox.id), 1);
      }
    }

    this.selectedContractArr = this.selectedContractArr1.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
  }

  addSelectedLocationPerCheckbox(checkBox: CheckBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedLocationPerCheckBoxList.push(checkBox.value);
      this.locationArrPer.push(checkBox.label);
      this.quickFilterFlag = true;
    } else {
      this.selectedLocationPerCheckBoxList.splice(this.selectedLocationPerCheckBoxList.indexOf(checkBox.value), 1);
      this.locationArrPer.splice(this.locationArrPer.indexOf(checkBox.label), 1);
    }
  }

  groupCheckbox(checkBox: CheckBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedGroupCheckBoxList.push(checkBox.value);
      this.groupArr.push(checkBox.label);
      this.quickFilterFlag = true;
    } else {
      this.selectedGroupCheckBoxList.splice(this.selectedGroupCheckBoxList.indexOf(checkBox.value), 1);
      this.groupArr.splice(this.groupArr.indexOf(checkBox.label), 1);
    }
  }

  equipCheckbox(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedEquipFunctionCheckBoxList.push(checkBox.id);
      this.equipFunArr.push(checkBox.value);
      this.quickFilterFlag = true;
    } else {
      this.selectedEquipFunctionCheckBoxList.splice(this.selectedEquipFunctionCheckBoxList.indexOf(checkBox.id), 1);
      this.equipFunArr.splice(this.equipFunArr.indexOf(checkBox.value), 1);
    }
  }

  addSelectedModelCheckbox(checkBox: CheckBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedModelCheckBoxList.push(checkBox.value);
    } else {
      this.selectedModelCheckBoxList.splice(this.selectedModelCheckBoxList.indexOf(checkBox.value), 1);
    }
  }

  mediaSupportCheckbox(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedmediaSupportBoxList.push(checkBox.id);
      console.log("selected media", this.selectedmediaSupportBoxList);
      this.mediaArr.push(checkBox.name);
      console.log("selected media arr", this.mediaArr);
      this.quickFilterFlag = true;
    } else {
      this.selectedmediaSupportBoxList.splice(this.selectedmediaSupportBoxList.indexOf(checkBox.id), 1);
      this.mediaArr.splice(this.mediaArr.indexOf(checkBox.name), 1);
    }
  }

  mediaFormatCheckbox(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedMediaFormtBoxList.push(checkBox.id);
      console.log("selected media", this.selectedMediaFormtBoxList);
      this.mediaFormatArr.push(checkBox.name);
      console.log("selected media format arr", this.mediaFormatArr);
      this.quickFilterFlag = true;
    } else {
      this.selectedMediaFormtBoxList.splice(this.selectedMediaFormtBoxList.indexOf(checkBox.id), 1);
      this.mediaFormatArr.splice(this.mediaFormatArr.indexOf(checkBox.name), 1);
    }
  }

  addSelectedLocationCheckbox(checkBox: CheckBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedLocationCheckBoxList.push(checkBox.value);
      this.locationArr.push(checkBox.value);
      this.quickFilterFlag = true;
    } else {
      this.selectedLocationCheckBoxList.splice(this.selectedLocationCheckBoxList.indexOf(checkBox.value), 1);
      this.locationArr.splice(this.locationArr.indexOf(checkBox.value), 1);
    }
  }

  addEquipmentTypeCheckBox(checkBox: CheckBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedEquipmentTypeCheckBoxList.push(checkBox.value);
      this.typeArr.push(checkBox.label);
      this.quickFilterFlag = true;
    } else {
      this.selectedEquipmentTypeCheckBoxList.splice(this.selectedEquipmentTypeCheckBoxList.indexOf(checkBox.value), 1);
      this.typeArr.splice(this.typeArr.indexOf(checkBox.label), 1);
    }
  }

  addSelectedBookedCheckbox1(checkBox: CheckBox) {
    checkBox.checked = !checkBox.checked;

    if (checkBox.checked) {
      this.selectedBookedCheckBoxList1.push(checkBox.label);
      this.activeArr.push(checkBox.label);
      this.quickFilterFlag = true;
    } else {
      this.selectedBookedCheckBoxList1.splice(this.selectedBookedCheckBoxList1.indexOf(checkBox.label), 1);
      this.activeArr.splice(this.activeArr.indexOf(checkBox.label), 1);
    }
  }

  addSelectedUserType(checkBox: CheckBox) {
    checkBox.checked = !checkBox.checked;

    if (checkBox.checked) {
      this.selectedUserType.push(checkBox.label);
      this.quickFilterFlag = true;
    } else {
      this.selectedUserType.splice(this.selectedUserType.indexOf(checkBox.label), 1);
    }
  }

  addSelectedPersonalType(checkBox: CheckBox) {
    checkBox.checked = !checkBox.checked;

    if (checkBox.checked) {
      this.selectedPersonalType.push(checkBox.label);
      this.quickFilterFlag = true;
    } else {
      this.selectedPersonalType.splice(this.selectedPersonalType.indexOf(checkBox.label), 1);
    }
  }

  addSelectedActualCheckbox(checkBox: CheckBox) {
    checkBox.checked = !checkBox.checked;

    if (checkBox.checked) {
      this.selectedActualCheckBoxList.push(checkBox.label);
      this.quickFilterFlag = true;
    } else {
      this.selectedActualCheckBoxList.splice(this.selectedActualCheckBoxList.indexOf(checkBox.label), 1);
    }
  }

  filterProject(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedProjectCheckBoxList.push(checkBox.id);
      this.quickFilterFlag = true;
    } else {
      this.selectedProjectCheckBoxList.splice(this.selectedProjectCheckBoxList.indexOf(checkBox.id), 1);
    }
  }

  filterNetwork(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedNetworkCheckBoxList.push(checkBox.id);
      this.quickFilterFlag = true;
    } else {
      this.selectedNetworkCheckBoxList.splice(this.selectedNetworkCheckBoxList.indexOf(checkBox.id), 1);
    }
  }

  filterKit(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedKitCheckBoxList.push(checkBox.id);
      this.quickFilterFlag = true;
    } else {
      this.selectedKitCheckBoxList.splice(this.selectedKitCheckBoxList.indexOf(checkBox.id), 1);
    }
  }

  filterClientCheckbox(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedclientCheckBoxList.push(checkBox.id);
      this.dclientArr.push(checkBox.name);
      this.quickFilterFlag = true;
    } else {
      this.selectedclientCheckBoxList.splice(this.selectedclientCheckBoxList.indexOf(checkBox.id), 1);
      this.dclientArr.splice(this.dclientArr.indexOf(checkBox.name), 1);
    }
  }

  filterPlanningCheckbox(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedPlanningCheckBoxList.push(checkBox.id);
      this.dPlanningArr.push(checkBox.statusName);
      this.quickFilterFlag = true;
    } else {
      this.selectedPlanningCheckBoxList.splice(this.selectedPlanningCheckBoxList.indexOf(checkBox.id), 1);
      this.dPlanningArr.splice(this.dclientArr.indexOf(checkBox.statusName), 1);
    }
  }

  filterProjectOwner(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedProjectOwnerList.push(checkBox.id);
      this.ownertagsArr.push(checkBox.fullName);
      this.quickFilterFlag = true;
    } else {
      this.selectedProjectOwnerList.splice(this.selectedProjectOwnerList.indexOf(checkBox.id), 1);
      this.ownertagsArr.splice(this.ownertagsArr.indexOf(checkBox.fullName), 1);
    }
  }

  filterPhaseManager(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedPhaseList.push(checkBox.id);
      this.phasetagsArr.push(checkBox.fullName);
      this.quickFilterFlag = true;
    } else {
      this.selectedPhaseList.splice(this.selectedPhaseList.indexOf(checkBox.id), 1);
      this.phasetagsArr.splice(this.phasetagsArr.indexOf(checkBox.fullName), 1);
    }
  }

  filterAccountManager(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedAccountManagerList.push(checkBox.id);
      this.accountManagertagsArr.push(checkBox.fullName);
      this.quickFilterFlag = true;
    } else {
      this.selectedAccountManagerList.splice(this.selectedAccountManagerList.indexOf(checkBox.id), 1);
      this.accountManagertagsArr.splice(this.accountManagertagsArr.indexOf(checkBox.fullName), 1);
    }
  }

  filterCountryCheckbox(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedCountryCheckBoxList.push(checkBox.name);
      this.quickFilterFlag = true;
    } else {
      this.selectedCountryCheckBoxList.splice(this.selectedCountryCheckBoxList.indexOf(checkBox.name), 1);
    }
  }

  filterRegionCheckbox(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.quickFilterFlag = true;
      this.selectedRegionCheckBoxList.push(checkBox.name);
    } else {
      this.selectedRegionCheckBoxList.splice(this.selectedRegionCheckBoxList.indexOf(checkBox.name), 1);
    }
  }

  filterCategoryCheckbox(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedCategoryCheckBoxList.push(checkBox.name);
      this.quickFilterFlag = true;
    } else {
      this.selectedCategoryCheckBoxList.splice(this.selectedCategoryCheckBoxList.indexOf(checkBox.name), 1);
    }
  }

  filterExportCheckbox(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedExportCheckBoxList.push(checkBox.label);
      this.quickFilterFlag = true;
    } else {
      this.selectedExportCheckBoxList.splice(this.selectedExportCheckBoxList.indexOf(checkBox.label), 1);
    }
  }

  addSelectedFinancial(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedFinancailCheckBoxList.push(checkBox.label);
      this.quickFilterFlag = true;
    } else {
      this.selectedFinancailCheckBoxList.splice(this.selectedFinancailCheckBoxList.indexOf(checkBox.label), 1);
    }
  }

  addSelectedTimeOff(checkBox) {
    checkBox.checked = !checkBox.checked;
    if (checkBox.checked) {
      this.selectedTimeOffCheckBoxList.push(checkBox.label);
      this.quickFilterFlag = true;
    } else {
      this.selectedTimeOffCheckBoxList.splice(this.selectedTimeOffCheckBoxList.indexOf(checkBox.label), 1);
    }
  }

  @HostListener("document:click", ["$event.target"])
  onClickedOutside(targetElement, target) {
    if (!targetElement.closest("#colorBox") && this.colorbox) {
      this.colorbox = false;
    }
    if (!targetElement.closest("#filter-id") && this.dropdownIndex != -1) {
      this.dropdownIndex = -1;
    }
  }

  createCronForm(): FormGroup {
    return this.formBuilder.group({
      MinuteEveryMinute: [2],
      HourEveryHour: [1],
      HourStartDate: [new Date()],
      HourStartTime: [null],
      DayEveryDay: [1],
      DayEveryStartTime: ["09:00"],
      WeekEveryWeek: [1],
      WeekEveryStartTime: ["09:00"],
      DayEveryStartDate: [new Date()],
      MonthEveryMonth: [1],
      MonthOnDate: [1],
      MonthStartTime: ["09:00"],
      MonthStartDate: [1],
      reportDays: [1],
      // DayspeficDay: this.formBuilder.array([])
    });
  }

  showCronModal() {
    let slectedModal = JSON.parse(localStorage.getItem("selectedReport"));
    if (slectedModal == 0) {
      this.selctedCronJob = "Personnel-Report";
    } else if (slectedModal == 1) {
      this.selctedCronJob = "Resource-Report";
    } else {
      this.selctedCronJob = "Project-Report";
    }
    this.cronModaLFlag = true;

    this.getCronJob();
  }

  onTabChangedAuto(event) {
    this.automationTab = event.index;
    const reportDaysControl = this.cronForm.get("reportDays");
    if (this.automationTab === 2) {
      reportDaysControl.setValue(7);
      reportDaysControl.disable();
    } else if (this.automationTab === 3) {
      reportDaysControl.setValue(30);
      reportDaysControl.disable();
    } else {
      reportDaysControl.setValue(1);
      reportDaysControl.enable();
    }
  }

  getCheckedWeekDays(obj, event) {
    if (obj != null) {
      obj.checked = event.target.checked;
    }
    this.selectedWeekDays = "";
    this.selectedWeekNumbers = "";
    for (let i = 0; i < this.cronDowDaysStartArr.length; i++) {
      let element = this.cronDowDaysStartArr[i];
      if (element.checked) {
        this.selectedWeekDays += element.name + ",";
        this.selectedWeekNumbers += element.val + ",";
      }
    }
    return this.selectedWeekDays;
  }

  async setCronExpression() {
    try {
      let croExp = null;
      if (this.automationTab == 0) {
        // let hour = Number(this.cronForm.get("HourEveryHour").value);
        // croExp = cronTime.every(hour).hours();
        let minutes = Number(this.cronForm.get("MinuteEveryMinute").value);
        croExp = cronTime.every(minutes).minutes();
      } else if (this.automationTab == 1) {
        let day = Number(this.cronForm.get("DayEveryDay").value);
        let startTime = this.cronForm.get("DayEveryStartTime").value;
        let hour = 0;
        let minute = 0;
        if (startTime) {
          hour = Number(startTime.split(":")[0]);
          minute = Number(startTime.split(":")[1]);
        }
        croExp = cronTime.every(day).days(hour, minute);
      } else if (this.automationTab == 2) {
        const startTime = this.cronForm.get("WeekEveryStartTime").value;
        let hour = 0,
          minute = 0;
        if (startTime) {
          [hour, minute] = startTime.split(":").map(Number);
        }

        let arr = this.selectedWeekNumbers
          .split(",")
          .filter(Boolean)
          .map((num) => Number(num) - 1);
        croExp = cronTime.onSpecificDaysAt(arr, hour, minute);
      } else {
        const monthDay = Number(this.cronForm.get("MonthOnDate").value);
        const startTime = this.cronForm.get("MonthStartTime").value;
        let hour = 0,
          minute = 0;
        if (startTime) {
          [hour, minute] = startTime.split(":").map(Number);
        }
        croExp = cronTime.everyMonthOn(monthDay, hour, minute);
      }

      let obj = {
        cronExpression: "0" + " " + croExp,
        actionType: this.selctedCronJob,
        recipient: this.selectedRecipient,
        data: null,
        filterId: this.selectedQuickFilterId,
        groupMembers: this.selectMembers,
        groupIds: this.selectedGroupIds,
        dateRange: Number(this.cronForm.get("reportDays").value) * 24 * 60 * 60 * 1000,
      };

      const res: any = await this.commonUtilService.setcronJob(obj);

      this.automationTab = 0;
      this.selectedGroup = null;
      this.selctedCronJob = null;
    } catch (error) {
      console.log(error);
    }
  }

  async setCronExpressionTest() {
    try {
      let obj = {
        cronExpression: "*/3 0 * * * *",
        actionType: this.selctedCronJob,
        recipient: this.selectedRecipient,
        data: null,
        groupMembers: this.selectMembers,
        groupIds: this.selectedGroupIds,
        dateRange: Number(this.cronForm.get("reportDays").value) * 24 * 60 * 60 * 1000,
      };

      const res: any = await this.commonUtilService.setcronJobTest(obj);

      this.automationTab = 0;
      this.selectedGroup = null;
      this.selctedCronJob = null;
    } catch (error) {
      console.log(error);
    }
  }

  locations(substring, string) {
    var a = [],
      i = -1;
    while ((i = string.indexOf(substring, i + 1)) >= 0) a.push(i);
    return a;
  }

  getgropuNameById(id) {
    // let obj =  null;
    let index = this.productionGroupList.findIndex((el) => el.id == id);
    if (index != -1) {
      return this.productionGroupList[index];
    } else {
      return null;
    }
  }

  async getCronJob() {
    try {
      this.runningJobObj = null;

      const res: any = await this.commonUtilService.getCronJob(this.selctedCronJob);
      this.runningJobObj = res.map((job) => {
        const matchedFilter = this.quickFilterArr.find((f) => f.id === job.filterId);
        return {
          ...job,
          filterName: matchedFilter?.filterName ?? "Complete Report",
        };
      });

      console.log("this is runningJobObj", this.runningJobObj);
    } catch (error) {
      console.log(error);
    }
  }

  async removeJob(job: any) {
    try {
      await this.commonUtilService.removeJob(job.jobId);
      this.runningJobObj = this.runningJobObj.filter((j) => j.jobId !== job.jobId);
    } catch (error) {
      console.error("Failed to remove job:", error);
    }
  }

  async resumeJob() {
    try {
      this.runningJobObj.groupMembers = this.getgroupMembersId(this.runningJobObj.groupIds);
      const res: any = await this.commonUtilService.resumeJob(this.runningJobObj);
      this.runningJobObj = null;
    } catch (error) {
      console.log(error);
    }
  }

  getProductionGroupData = () => {
    let productionGroupDataAPI = this.httpService.callApi("getProductionGroups", {});
    let groupApi = this.httpService.callApi("getGroups", {});
    forkJoin([productionGroupDataAPI, groupApi]).subscribe(
      (resultList) => {
        this.productionGroupList = resultList[0].map((el) => ({
          ...el,
          customId: `production-${el.id}`,
        }));
        this.productionGroupList.push(...resultList[1].map((el) => ({ ...el, customId: `group-${el.id}` })));
      },
      (errorList) => {}
    );
  };

  getGroupSubStatus(item: any) {
    let index = this.selectGroupArr1.findIndex((el) => el == item);
    if (index == -1) {
      this.selectGroupArr1.push(item);
      this.toastr.success(`${item} group added to recipient`);
      this.selecttedRecipents(this.selectGroupArr1);
      let index = this.productionGroupList.findIndex((el) => el.name == item);
      if (index != -1) {
        this.groupCronName.push(this.productionGroupList[index].name);
        this.groupIds1.push(this.productionGroupList[index].id);
      }
    }
    this.assignedGroup1 = "";
  }

  getgroupMembersId(arr) {
    let groupMembers: any = [];
    for (let i = 0; i < arr.length; i++) {
      for (let j = 0; j < this.productionGroupList.length; j++) {
        if (this.productionGroupList[j].id == arr[i]) {
          for (let k = 0; k < this.productionGroupList[j].groupMembers.length; k++) {
            if (this.productionGroupList[j].groupMembers[k].id != undefined || this.productionGroupList[j].groupMembers[k].id != null) {
              let index = groupMembers.findIndex((el) => el.id == this.productionGroupList[j].groupMembers[k].id);
              if (index == -1) {
                let obj = {
                  id: this.productionGroupList[j].groupMembers[k].id,
                };
                groupMembers.push(obj);
              }
            }
          }
        }
      }
    }
    return groupMembers;
  }

  selecttedRecipents(arr: any) {
    let recipentObj: any = [];
    let groupMembers: any = [];
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].includes("@")) {
        recipentObj.push(arr[i]);
      }
      for (let j = 0; j < this.productionGroupList.length; j++) {
        if (this.productionGroupList[j].name.toString() == arr[i].toString()) {
          for (let k = 0; k < this.productionGroupList[j].groupMembers.length; k++) {
            if (this.productionGroupList[j].groupMembers[k].id != undefined || this.productionGroupList[j].groupMembers[k].id != null) {
              let index = groupMembers.findIndex((el) => el.id == this.productionGroupList[j].groupMembers[k].id);
              if (index == -1) {
                let obj = {
                  id: this.productionGroupList[j].groupMembers[k].id,
                };
                groupMembers.push(obj);
              }
            }
          }
        }
      }
    }
    this.selectedRecipient = recipentObj;
    this.selectMembers = groupMembers;

    this.selectedGroupIds = this.groupIds1;
  }

  removeGroup1(obj: any) {
    let index = this.selectGroupArr1.findIndex((el) => el == obj);
    if (index != -1) {
      this.toastr.success(`${obj} group removed from recipient`);
      this.selectGroupArr1.splice(index, 1);
      let pindex = this.productionGroupList.findIndex((el) => el.name == obj);
      if (pindex != -1) {
        this.groupIds1.splice(pindex, 1);
      }
    }
  }

  toggleRecipientDropdown(index: number): void {
    this.expandedRecipientIndex = this.expandedRecipientIndex === index ? null : index;
  }
  onQuickFilterChange(filter: string) {
    if (filter && filter !== "undefined") {
      this.selectedQuickFilter = filter;
      const matchedFilter = this.quickFilterArr.find((f) => f.filterName === filter);
      if (matchedFilter) {
        this.selectedQuickFilterId = matchedFilter.id;
      } else {
        this.selectedQuickFilterId = null;
        console.log("Selected filter name does not match any known filters.");
      }
    } else {
      this.selectedQuickFilter = "";
      this.selectedQuickFilterId = null;
    }
  }
}
